import {Box, HStack, Icon, Show, Text, ThemeColorPath} from 'platform/foundation';

import {isNotNil} from 'ramda';

import {suffixTestId, TestIdProps} from 'shared/web';

interface RealSellingPriceBannerProps extends TestIdProps {
  variant: 'warning' | 'success';
  message?: string;
  heading: string;
}

export function RealSellingPriceBanner(props: RealSellingPriceBannerProps) {
  const messageColor: ThemeColorPath =
    props.variant === 'success' ? 'palettes.green.20.100' : 'palettes.yellow.20.100';

  return (
    <Box
      backgroundColor={messageColor}
      borderRadius="small"
      paddingVertical={3}
      paddingHorizontal={4}
    >
      <HStack spacing={2} align="center">
        <Icon
          value={props.variant === 'success' ? 'action/trending_up' : 'action/trending_down'}
          color={props.variant === 'success' ? 'severity.success' : 'severity.warning'}
          size={4}
          data-testid={suffixTestId('trend', props)}
        />
        <HStack>
          <Text alternative size="small" data-testid={suffixTestId('heading', props)}>
            {props.heading}
            <Show when={isNotNil(props.message)}>
              <Text inline size="small" data-testid={suffixTestId('message', props)}>
                {` ${props.message}`}
              </Text>
            </Show>
          </Text>
        </HStack>
      </HStack>
    </Box>
  );
}
